import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IConfirmationDialogInput} from "../../types/confirmation.type";
import {IBidderComplaint} from "../../../procurement-process/components/bidder-complaint/bidder-complaint.types";
import {FormBuilder, FormGroup} from "@angular/forms";
import {FormValidationService} from "../../services/form-validation/form-validation.service";
import {NotificationsService} from "../../services/notifications.service";

@Component({
  selector: 'app-rejection-reason-dialog',
  templateUrl: './rejection-reason-dialog.component.html',
  styleUrls: ['./rejection-reason-dialog.component.styl']
})
export class RejectionReasonDialogComponent implements OnInit {
  form: FormGroup;
  constructor(public dialogRef: MatDialogRef<RejectionReasonDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IConfirmationDialogInput,
              private formBuilder: FormBuilder,
              private formValidationService: FormValidationService,
              public notificationsService: NotificationsService) {
  }

  ngOnInit() {
    this.initForm();
  }

  submit() {
    this.dialogRef.close({
      isConfirmed: true,
      data: this.form.value
    });
  }

  cancel() {
    this.dialogRef.close({
      isConfirmed: false,
    });
  }


  initForm() {
    this.form = this.formBuilder.group({
      rejection_reason: ['', this.formValidationService.required.validator],

    } as any);
  }

  isValid(): boolean {
    return this.form && this.form.valid;
  }
}
